import { message } from 'antd';
import lodash from 'lodash';
import React from 'react';
import { Link } from 'react-router-dom';
import { DesignPro, Locales } from '../mambas';
import antd from './antd';
import { valueTypeMap } from "./extendsFields";
import icons from './icons';
const Ant = {
    /** 路由导航 */
    Link,
    message,
    ...antd,
    ...DesignPro,
}
// 多语言
Locales.init({
    pagesContext: require.context('@/pages', true, /locales.ts$/)
})
// 自定义 valueType  https://procomponents.ant.design/components/schema#%E8%87%AA%E5%AE%9A%E4%B9%89-valuetype
DesignPro.setValueTypeMap(valueTypeMap)
// 转换一个 由组件名称组成的 key集合
const EnumValueType = lodash.mapValues(valueTypeMap, (val, key) => key)
lodash.set(React, 'Antd', Ant)
lodash.set(React, 'Icons', icons)
lodash.set(React, 'valueType', lodash.assign({}, DesignPro.baseValueType, EnumValueType))
declare module 'react' {
    const valueType: (typeof EnumValueType) & (typeof DesignPro.baseValueType)
    /**
     * ant 组件列表
     */
    const Antd: typeof Ant;
    /**
     * 图标
     */
    const Icons: typeof icons;

}
